const map = {
	"./sponsor-images/platinum/safety-national-logo.png": 16,
	"./sponsor-images/silver/ARC_PT-logo.jpg": 717,
	"./sponsor-images/site-supporter/mac-logo.png": 902,
	"./sponsor-images/site-supporter/mada-logo.png": 220,
	"./sponsor-images/site-supporter/mmma-logo.jpg": 405,
	"./sponsors": 870,
	"./sponsors.json": 870
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;